import React from "react"
import { CardDeck as ReactstrapCardDeck, CardDeckProps } from "reactstrap"

export const CardDeck: React.FC<CardDeckProps> = props => {
  return <ReactstrapCardDeck {...props} />
}
